module.exports = __webpack_public_path__ + "img/emails-rafiki.622dc953.png";